module.exports = __webpack_public_path__ + "static/media/mirror_munich.48625a0a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/personal/normals/mirror_munich.jpg
// module id = 424
// module chunks = 0